export default __webpack_public_path__ + "assets/images/gift_small.8e830b.webp";